import { createClient } from '@supabase/supabase-js';

import { Database } from '@/types/database';

// TODO: Import from zod validated env

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL) throw new Error('Missing VITE_SUPABASE_URL');
if (!SUPABASE_KEY) throw new Error('Missing VITE_SUPABASE_ANON_KEY');

export const supabaseClient = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_KEY,
);
